(function () {
  'use strict';
  if (window.__noahsFlashyGifts) return;
  window.__noahsFlashyGifts = true;

  var debug = new URLSearchParams(window.location.search).has('flashy-preview') ||
    new URLSearchParams(window.location.search).has('noahs-gift-debug');
  function log(stage, details) {
    if (debug) console.info('[NOAHS Gifts]', stage, details || '');
  }
  log('loaded', { version: 3 });
  var busy = false;
  var giftIds = ['46347735597187', '46347734745219', '46380256362627'];
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  async function request(path, options) {
    log('request', { path: path, method: (options && options.method) || 'GET' });
    var response = await fetch(root + path, Object.assign({ credentials: 'same-origin' }, options));
    log('response', { path: path, status: response.status });
    var data = await response.json();
    if (!response.ok) throw new Error(data.description || 'לא ניתן להוסיף כרגע. נסו שוב.');
    return data;
  }

  function closeGiftPopup(popup) {
    var popupRoot = popup.getRootNode();
    var host = popup.closest('flashy-popup') || popupRoot.host;
    // Scope closing to the Flashy popup containing the selected gift.
    if (!host || host.localName !== 'flashy-popup') {
      log('popup close unavailable', { reason: 'Flashy host not found' });
      return;
    }
    var scope = host.shadowRoot || host;
    var closeButton = scope.querySelector('.fls-close-popup, [data-ev*="closePopup"]');
    try {
      if (closeButton) {
        closeButton.click();
      } else if (typeof host.close === 'function') {
        host.close();
      }
      log('popup closed');
    } catch (error) {
      log('popup close failed', { message: error.message });
    }
  }

  function openDrawer() {
    var drawer = document.getElementById('CustomCartDrawer');
    log('drawer', { found: !!drawer, openFunction: typeof window.openCustomCartDrawer });
    if (drawer && typeof window.openCustomCartDrawer === 'function') {
      // Raise the drawer above the popup; visibility remains controlled by the theme.
      drawer.style.setProperty('z-index', '2147483647', 'important');
      window.openCustomCartDrawer();
      // This gift flow keeps the page scrollable and removes the theme's page blur.
      document.body.classList.remove('cd-no-scroll', 'cd-blur-active');
      log('drawer opened', { isOpen: drawer.classList.contains('is-open') });
    } else {
      window.location.assign(root + 'cart');
    }
  }

  window.addEventListener('click', async function (event) {
    // Shadow DOM retargets event.target to the popup host. Inspect the original path.
    var path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
    var button = null;
    for (var i = 0; i < path.length; i++) {
      if (path[i] && typeof path[i].closest === 'function') {
        button = path[i].closest('.noahs-gifts .gift-add-btn');
        if (button) break;
      }
    }
    if (!button) return;
    log('gift click', { variantId: button.dataset.variantId, busy: busy, disabled: button.disabled });
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy || button.disabled) return;

    var variantId = button.dataset.variantId;
    if (giftIds.indexOf(variantId) === -1) return;
    var popup = button.closest('.noahs-gifts');
    var status = popup.querySelector('.gift-status');
    var buttons = Array.from(popup.querySelectorAll('.gift-add-btn'));
    var previousStates = buttons.map(function (item) { return item.disabled; });
    var originalText = button.textContent;
    var added = false;
    busy = true;
    buttons.forEach(function (item) { item.disabled = true; });
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'מוסיף…';
    if (status) { status.className = 'gift-status'; status.textContent = ''; }

    try {
      var cart = await request('cart.js', { cache: 'no-store' });
      var existingGift = cart.items.some(function (item) {
        return giftIds.indexOf(String(item.variant_id)) !== -1;
      });
      if (!existingGift) {
        await request('cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties: { '_Free Gift': 'Yes' } }] })
        });
      }
      added = true;
      button.textContent = existingGift ? originalText : 'נוסף לסל ✓';
      if (status) {
        status.className = 'gift-status success';
        status.textContent = existingGift ? 'כבר יש מתנה בסל שלך' : 'המתנה נוספה לסל';
      }
      closeGiftPopup(popup);
      openDrawer();
    } catch (error) {
      log('failed', { message: error.message });
      button.textContent = originalText;
      if (status) { status.className = 'gift-status error'; status.textContent = error.message; }
    } finally {
      busy = false;
      button.removeAttribute('aria-busy');
      if (!added) buttons.forEach(function (item, index) { item.disabled = previousStates[index]; });
    }
  }, true);
})();
